<div class="flex-container">
  <div class="flex-row">
    <div class="flex-col-12" *ngIf="!technicalIssuesRecognized && !endValuesIssues">
      <app-risk-recheck-box *ngIf="showRecheck" [riskRecheck]="riskRecheck"></app-risk-recheck-box>
      <app-super-human-survey-box
        *ngIf="showSuperhuman"
        [superhuman]="superhuman"
        [notificationId]="notificationId"
      ></app-super-human-survey-box>

      <app-promo-banner
        *ngFor="let promoCampaign of promoCampaigns$ | async"
        [currency]="currentAccount.currency"
        [language]="customer.language"
        [campaign]="promoCampaign"
      ></app-promo-banner>
      <ng-container *ngIf="isInitialised">
        <div *ngIf="daysDifference === 0; else showReporting">
          <ng-container *ngIf="currentAccount?.current_amount >= minFundingAmount; else lowAssets">
            <div class="action-info-box">
              <div class="icon-bg info">
                <img src="/assets/images/info-circle.svg" alt="" />
              </div>
              <div class="content">
                <h2>
                  {{ (is3A ? 'performance.header.ready_invest.h3_3a' : 'SHARED.projectMini.waitingForTradingDay.title') | translate }}
                </h2>
                <h4 *ngIf="is3A">{{ 'performance.header.ready_invest.sub_3a' | translate: { currency: currentAccount?.currency } }}</h4>
                <p
                  [innerHTML]="
                    (is3A ? 'performance.header.ready_invest.p_3a' : 'SHARED.projectMini.waitingForTradingDay.description') | translate
                  "
                ></p>
              </div>
            </div>
          </ng-container>
          <ng-template #lowAssets>
            <div class="action-info-box">
              <div class="icon-bg {{ currentAccount.has_low_investment_balance ? 'cross' : 'info' }}">
                <img src="/assets/images/{{ currentAccount.has_low_investment_balance ? 'cross' : 'info' }}-circle.svg" alt="" />
              </div>
              <div class="content">
                <h2>
                  {{
                    (currentAccount.has_low_investment_balance
                      ? 'SHARED.projectMini.callout.title'
                      : 'SHARED.projectMini.notInvested.title'
                    ) | translate
                  }}
                </h2>
                <p>
                  {{
                    (currentAccount.has_low_investment_balance
                      ? 'SHARED.projectMini.callout.description'
                      : 'SHARED.projectMini.notInvested.description'
                    ) | translate: { amount: stillNeededFundingAmount | translateNumber: customer.language : currentAccount.currency }
                  }}
                </p>
              </div>
              <button
                (click)="onShowAccountDetails()"
                class="ui-button {{ currentAccount.has_low_investment_balance ? 'primary' : 'secondary' }}"
              >
                {{
                  (currentAccount.has_low_investment_balance
                    ? 'SHARED.projectMini.callout.link'
                    : 'SHARED.projectMini.notInvested.buttonLabel'
                  ) | translate
                }}
              </button>
            </div>
          </ng-template>
        </div>
        <ng-template #showReporting>
          <app-min-fund-box
            *ngIf="currentAccount.has_low_investment_balance"
            [currency]="currentAccount.currency"
            [minFundingAmount]="stillNeededFundingAmount"
            [language]="customer.language"
          >
          </app-min-fund-box>
          <h1>
            {{
              (is3A ? 'performance.title-3a' : currentAccount.kind === 'kid' ? 'performance.title-kids' : 'performance.title')
                | translate: { kidsName: currentAccount.owner_name }
            }}
          </h1>
          <app-reporting-header
            [customer]="customer"
            [currentAccount]="currentAccount"
            [daysDifference]="daysDifference"
          ></app-reporting-header>

          <app-reporting-chart [customer]="customer" [currentAccount]="currentAccount"></app-reporting-chart>
          <app-reporting-transaction-section
            [customer]="customer"
            [currentAccount]="currentAccount"
            *ngIf="isInitialised && daysDifference > 0"
          ></app-reporting-transaction-section>
        </ng-template>
      </ng-container>
    </div>

    <div class="flex-col-12" *ngIf="technicalIssuesRecognized || endValuesIssues">
      <app-reporting-technical-issue [kind]="currentAccount.kind"></app-reporting-technical-issue>
    </div>
  </div>
</div>

<app-footer>
  <ng-container *ngIf="currentAccount?.step_status === 5">
    <button
      (click)="track()"
      routerLink="/adjust-investment"
      class="ui-button"
    >
      {{ 'reinvest.savings_cta' | translate }}
    </button>
  </ng-container>
</app-footer>
